import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-content-details',
  templateUrl: './content-details.component.html',
  styleUrls: ['./content-details.component.scss']
})
export class ContentDetailsComponent implements OnInit {
  publishID:string;
  contentDetails:[];
  publishDetails:[];
  noticeContent:any;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { 

      this.publishID =  this.activatedRoute.snapshot.paramMap.get('id');

    }

  ngOnInit() {

    let contentData = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID"),     
      publishID:this.publishID
      
    }

    this.apiService.publishDetails(contentData).subscribe((res:any)=>{
      console.log(res);
      //this.contentList = res.data.vendorPublishList.data.publishList;
      this.contentDetails = res.data.vendorPublish.data.contentDetails;
      this.publishDetails = res.data.vendorPublish.data.publishDetails;
  },async err => {
     
  })

  }

  download(url){    
    window.open(url);
  }
  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  
  enrollment(){   
    this.router.navigateByUrl(`enrollment`);
  }
  
  
  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  requirement(){
    
  }
  

  }


